// extracted by mini-css-extract-plugin
export default {"eventList":"CalendarEventList_eventList__5On9w","eventListItem":"CalendarEventList_eventListItem__zlg5l"};